export abstract class Message<TMessageTypeEnum, TBody = any> {
  constructor(readonly type: TMessageTypeEnum, readonly body?: TBody) {}
}
